import React from 'react'
import { SidebarType } from '../Sidebar/Sidebar'
import NavMenuButton from './MainActionButton/NavMenuButton.tsx'
import Icon from '../common/Icon.tsx'
import ZoomBar from './ZoomBar/ZoomBar.tsx'
import useUiStore from '../../shared/store/ui.store.tsx'
import { useShallow } from 'zustand/react/shallow'
import { selectClip } from '@/features/clips/domain/use-cases/select-clip.ts'

const NavMenu: React.FC<{ isLoading: boolean }> = ({ isLoading }) => {
  const { sidebarType, setSidebarType, isSidebarOpen } = useUiStore(
    useShallow((state) => ({
      sidebarType: state.sidebarType,
      setSidebarType: state.setSidebarType,
      isSidebarOpen: state.isSidebarOpen,
    }))
  )

  const selectSidebarType = (type: SidebarType) => {
    selectClip(undefined)
    setSidebarType(type)
  }

  return (
    <div className="navigation">
      {isLoading && (
        <div className="absolute left-0 top-0 z-50 h-full w-full bg-zinc-900/85" />
      )}
      <div className="flex gap-2">
        <NavMenuButton
          textKey="ls_main_action_scripts"
          iconName="sparkles"
          isActive={
            (sidebarType === SidebarType.Scripts ||
              sidebarType === SidebarType.Voices) &&
            isSidebarOpen
          }
          onClick={() => selectSidebarType(SidebarType.Scripts)}
          dataTestId="nav-generate-speech"
        />
        <NavMenuButton
          textKey="ls_main_action_sound_designs"
          iconName="drum"
          isActive={sidebarType === SidebarType.SoundDesigns && isSidebarOpen}
          onClick={() => selectSidebarType(SidebarType.SoundDesigns)}
          dataTestId="nav-sound-designs"
        />
        <NavMenuButton
          textKey="ls_main_action_sound_effects"
          iconName="audio"
          isActive={sidebarType === SidebarType.SoundEffects && isSidebarOpen}
          onClick={() => selectSidebarType(SidebarType.SoundEffects)}
          dataTestId="nav-sound-effects"
        />
        <NavMenuButton
          textKey="ls_main_action_media"
          iconName="folderAudio"
          isActive={sidebarType === SidebarType.MediaFiles && isSidebarOpen}
          onClick={() => selectSidebarType(SidebarType.MediaFiles)}
          dataTestId="nav-media-files"
        />
      </div>
      <div className="flex gap-4 px-3">
        <ZoomBar />
        <Icon name={'arrowExpandOut'} />
      </div>
    </div>
  )
}

export default React.memo(NavMenu)
